// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__H8DEu","buttons":"styles_buttons__3ee8t"};